import { ReactElement } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { NON_EMPLOYEE_USER_TYPES, PAGE_ROUTES } from './_const';
import PageWithBreadcrumbs from './components/layouts/NEPageWithBreadcrumbs';
import ViewLayout from './components/layouts/ViewLayout';

/**
 * Intended purpose: landing page for Non-Employee Creation Page
 * @returns {ReactElement} user type selection view
 */
const Home = () => {
	const history = useHistory();
	return (
		<>
			<Redirect
				to={`/index.html?page=/ESO/NonEmployee_Agreement.aspx?user=0`}
			/>
			{/* 
				Temporarily redirect back to the old Non-Employee page. 
				Keep below as a starting point for future non-employee creation home page. 
			*/}
			<PageWithBreadcrumbs>
				<ViewLayout
					title={'Non-Employee User Type Selection'}
					help={{
						title: 'Create New Non-Employee: EpicCare Link User',
						contents: (
							<Stack direction={'column'} spacing={2}>
								<Typography>
									This workflow is designed for EpicCare Link
									site administrators who wish to register new
									EpicCare Link Users and request EpicCare
									Link application access through IMS.
								</Typography>
								<Typography>
									This is a more streamlined workflow than
									requesting a new Non-Employee (
									<a
										href={PAGE_ROUTES.LEGACY_HOME}
										rel='noopener noreferrer'
										target='_parent'
									>
										Request &gt; Add Non-Employee Account
									</a>
									) and makes several assumptions about you,
									the requestor, and the new non-employee
									account you are creating. Please do not use
									this form unless you are an EpicCare site
									administrator and you are requesting
									EpicCare Link application access for a new
									non-employee user.
								</Typography>
								<Typography>
									If the EpicCare Link User has already been
									registered with IMS and you are looking to
									request EpicCare Link, please leave this
									page and navigate to the application request
									workflow (
									<a
										href='/index.html?redirect=/RequestFlow/RequesteeSearch'
										rel='noopener noreferrer'
										target='_parent'
									>
										Request &gt; Application Access &gt; App
										Request For Others
									</a>
									)
								</Typography>
								<Typography>
									For a more detailed usage guide, please
									refer to the{' '}
									<a
										href='https://infonet.upmc.com/infonet/ls/content/8932526666595017/add-non-employee-as-epiccare-link-user-pdf-1764799986'
										rel='noopener noreferrer'
										target='_blank'
									>
										Add a Non-Employee as an EpicCare Link
										User - Guide for Site Admins
									</a>{' '}
									tip-sheet on InfoNet.
								</Typography>
							</Stack>
						),
					}}
				>
					<ul>
						{NON_EMPLOYEE_USER_TYPES.map(userType => {
							return (
								<>
									<li
										key={userType.id}
										onClick={() =>
											history.push(userType.redirectUrl)
										}
									>
										{userType.name}
									</li>
									{userType.description && (
										<ul>
											<li>{userType.description}</li>
										</ul>
									)}
								</>
							);
						})}
					</ul>
				</ViewLayout>
			</PageWithBreadcrumbs>
		</>
	);
};

export default Home;
